"use strict";

module.exports = function (cond, ifTrue, ifFalse) {
  return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};